import React, { useState } from 'react';
import type { SelectOption } from '@wix/cli-ui-kit';
import type { SupportedServicePlugin } from '@wix/cli-app-definitions';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { useProjectModel } from '../../../model.js';
import { generateServicePlugin } from './generate.js';
import { ChooseNameStep, SelectServicePluginStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateServicePlugin = () => {
  const { model } = useProjectModel();

  const [typeOption, setTypeOption] =
    useState<SelectOption<SupportedServicePlugin>>();
  const [name, setName] = useState<string>();

  const generationTask = useGenerationTask(async () => {
    if (name && typeOption) {
      const result = await generateServicePlugin(
        model.projectFolder,
        typeOption.value,
        name
      );

      return result;
    }
  }, [name, typeOption]);

  return [
    <SelectServicePluginStep
      onSubmit={setTypeOption}
      typeOption={typeOption}
    />,
    <ChooseNameStep onSubmit={setName} name={name} type={typeOption?.value} />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'service plugin'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        learnMoreUrl: 'https://dev.wix.com/docs/go-headless',
      })}
    />,
  ];
};
